import React, { useState} from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import TeacherFeedback from "../components/TeacherFeedback";
import home from "../images/home.png";
import feedback from "../images/feedback.png";
import history from "../images/history.png";
import tutorials from "../images/tutorials.png";
import "../styles/TeacherDashboard.css";

const TeacherFeedbackPage = () => {
  const [activeItem, setActiveItem] = useState("feedback");
  const [isVideoMode, setIsVideoMode] = useState(true);
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");

  const toggleMode = (mode) => {
    setIsVideoMode(mode);
  };

  const resetSearch = () => {
    setSearchQuery(""); 
  };

  const teacherMenuItems = [
    { icon: home, label: "Home", key: "home" },
    { icon: feedback, label: "Feedback", key: "feedback" },
    { icon: tutorials, label: "Tutorials", key: "tutorials", disabled: true },
    { icon: history, label: "History", key: "history", disabled: true },
  ];

  // Determine which parts of the header to show based on the active menu item
  const getHeaderVisibility = () => {
    if (activeItem === "home" || activeItem === "") {
      return { showSearch: true, showToggle: true, showUserProfile: false };
    } else if (activeItem === "feedback") {
      return { showSearch: false, showToggle: false, showUserProfile: true };
    } else if (activeItem === "tutorials") {
      return { showSearch: true, showToggle: false, showUserProfile: true };
    }
    return { showSearch: false, showToggle: false, showUserProfile: true };
  };
  const { showSearch, showToggle, showUserProfile } = getHeaderVisibility();

  const handleActiveItemChange = (item) => {
    setActiveItem(item); // Update active item

    // Navigate to the correct route
    if (item === "feedback") {
      navigate("/teacherFeedback"); // Navigate to feedback page
    } else if (item === "home") {
      navigate("/teacher"); // Navigate to home page
    }

    resetSearch(); // Reset search whenever a new section is selected
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    setActiveItem(""); // No active menu item during search
  };


  return (
    <div className="dashboard">
      <Header
        isVideoMode={isVideoMode}
        toggleMode={toggleMode}
        showSearch={showSearch}
        showToggle={showToggle}
        showUserProfile={showUserProfile}
        searchQuery={searchQuery}
        onSearch={handleSearch}
      />
      <main className="main-content">
        <Sidebar
          activeItem={activeItem}
          setActiveItem={handleActiveItemChange}
          menuItems={teacherMenuItems}
          resetSearch={resetSearch}
        />
        <div className="content">
          <TeacherFeedback />
        </div>
      </main>
    </div>
  );
};

export default TeacherFeedbackPage;
